import {
  TRENDMICRO_INTEGRATION_CONFIG_REQUEST,
  TRENDMICRO_INTEGRATION_CONFIG_SUCCESS,
  TRENDMICRO_INTEGRATION_CONFIG_ERROR,
  TRENDMICRO_INTEGRATION_CONFIG_SET,
  TRENDMICRO_INTEGRATION_CONFIG_CREATE_REQUEST,
  TRENDMICRO_INTEGRATION_CONFIG_UPDATE_REQUEST,
  TRENDMICRO_INTEGRATION_CONFIG_UPDATE_SUCCESS,
  TRENDMICRO_INTEGRATION_CONFIG_UPDATE_ERROR
} from './trendmicro-integration.type'

import ApiRest from '@/api/api-rest'

const state = {
  trendmicroIntegrationConfigReqStatus: '',
  trendmicroIntegrationConfigUpdateReqStatus: '',
  trendmicroIntegrationConfig: {
    nickName: null,
    port: null,
    ssl: null,
    ip: null
  }
}

const getters = {
  trendmicroIntegrationConfigReqStatus: state => state.trendmicroIntegrationConfigReqStatus,
  trendmicroIntegrationConfigUpdateReqStatus: state => state.trendmicroIntegrationConfigUpdateReqStatus,
  trendmicroIntegrationConfig: state => state.trendmicroIntegrationConfig
}

// Best Practice - updates state
const mutations = {
  [TRENDMICRO_INTEGRATION_CONFIG_REQUEST]: state => (state.trendmicroIntegrationConfigReqStatus = 'loading'),
  [TRENDMICRO_INTEGRATION_CONFIG_SUCCESS]: state => (state.trendmicroIntegrationConfigReqStatus = 'saved'),
  [TRENDMICRO_INTEGRATION_CONFIG_ERROR]: state => (state.trendmicroIntegrationConfigReqStatus = 'error'),
  [TRENDMICRO_INTEGRATION_CONFIG_SET]: (state, settings) => {
    state.trendmicroIntegrationConfig = settings
  },
  [TRENDMICRO_INTEGRATION_CONFIG_UPDATE_REQUEST]: state =>
    (state.trendmicroIntegrationConfigUpdateReqStatus = 'inprogress'),
  [TRENDMICRO_INTEGRATION_CONFIG_UPDATE_SUCCESS]: state => (state.trendmicroIntegrationConfigUpdateReqStatus = 'saved'),
  [TRENDMICRO_INTEGRATION_CONFIG_UPDATE_ERROR]: state => (state.trendmicroIntegrationConfigUpdateReqStatus = 'error')
}

// Best Practice - actions call mutations
// make api call and commit states
const actions = {
  [TRENDMICRO_INTEGRATION_CONFIG_SET] (context, account) {
    context.commit(TRENDMICRO_INTEGRATION_CONFIG_SET, account)
  },
  [TRENDMICRO_INTEGRATION_CONFIG_REQUEST] (context, account) {
    context.commit(TRENDMICRO_INTEGRATION_CONFIG_REQUEST)
    return new Promise((resolve, reject) => {
      ApiRest()
        .get('/integrations/configure/trendmicro')
        .then(({ data }) => {
          context.commit(TRENDMICRO_INTEGRATION_CONFIG_SET, {
            nickName: data.nickName,
            port: parseInt(data.port),
            ssl: data.ssl,
            ip: data.ip
          })
          context.commit(TRENDMICRO_INTEGRATION_CONFIG_SUCCESS)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(TRENDMICRO_INTEGRATION_CONFIG_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [TRENDMICRO_INTEGRATION_CONFIG_CREATE_REQUEST] (context, payload) {
    return new Promise((resolve, reject) => {
      context.commit(TRENDMICRO_INTEGRATION_CONFIG_REQUEST)
      ApiRest()
        .post('/integrations/configure/trendmicro', {
          nickName: payload.nickName,
          port: parseInt(payload.port),
          ssl: payload.ssl ? payload.ssl : false,
          ip: payload.ip
        })
        .then(resp => {
          context.commit(TRENDMICRO_INTEGRATION_CONFIG_SET, payload)
          context.commit(TRENDMICRO_INTEGRATION_CONFIG_SUCCESS, resp)
          resolve(resp)
        })
        .catch(errMsg => {
          context.commit(TRENDMICRO_INTEGRATION_CONFIG_UPDATE_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [TRENDMICRO_INTEGRATION_CONFIG_UPDATE_REQUEST] (context, payload) {
    return new Promise((resolve, reject) => {
      context.commit(TRENDMICRO_INTEGRATION_CONFIG_UPDATE_REQUEST)
      ApiRest()
        .put(`/integrations/configure/trendmicro/${payload.key}`, {
          nickName: payload.nickName,
          port: parseInt(payload.port),
          ssl: payload.ssl ? payload.ssl : false,
          ip: payload.ip
        })
        .then(resp => {
          context.commit(TRENDMICRO_INTEGRATION_CONFIG_SET, payload)
          context.commit(TRENDMICRO_INTEGRATION_CONFIG_UPDATE_SUCCESS, resp)
          resolve(resp)
        })
        .catch(errMsg => {
          context.commit(TRENDMICRO_INTEGRATION_CONFIG_UPDATE_ERROR, errMsg)
          reject(errMsg)
        })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/integrations/trendmicro-integration-config.module.js